export const getNoticeList = async function (param) {
    const requestURL = "/notice/web/list";
    const requestParam = param;

    const response = await o2.util.Http.requestData(requestURL, requestParam, {parameterType: "json"});

    return response;
};

export const getNotice = async function (noticeId) {
    const requestURL = `/notice/${noticeId}`;
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};
